import { getCurrentTranslations } from "../l10n/localization";
export const Validator = {
    required(control) {
        if (control.value == undefined ||
            control.value === '' ||
            control.value === 0 ||
            control.value === false ||
            (Array.isArray(control.value) && control.value.length === 0)) {
            const T = getCurrentTranslations();
            return {
                validator: 'required',
                message: T.get('validation.required', control.displayName),
            };
        }
        else {
            return null;
        }
    },
    minmax(min, max) {
        return function minmax(control) {
            const value = +control.value;
            if (!isNaN(min) && value < min) {
                const T = getCurrentTranslations();
                return {
                    validator: 'minmax',
                    message: T.get('validation.minmaxNotLessThen', control.displayName, min),
                };
            }
            else if (!isNaN(max) && value > max) {
                const T = getCurrentTranslations();
                return {
                    validator: 'minmax',
                    message: T.get('validation.minmaxNotGreaterThen', control.displayName, max),
                };
            }
            else {
                return null;
            }
        };
    }
};
